import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  padding: 16px;
  gap: 16px;
  background-color: #f5f5f5;
  overflow-y: auto;

  font-family: 'Poppins';
`;

export const Header = styled.div`
  width: 100%;
  justify-content: space-between;
  display: flex;
  align-items: center;
`;

export const Title = styled.h2`
  margin: 0;

  color: #666;
  font-family: Poppins;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const CategoriesContainer = styled(motion.div)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  overflow-y: auto;
`;

export const Card = styled(motion.div)`
  padding: 12px;
  background: ${({ theme }) => theme.colors.neutral.white};
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  h1 {
    margin: 0;
    color: ${({ theme }) => theme.colors.primary.default};
    font-family: Poppins;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px; /* 127.273% */
    letter-spacing: var(--Headline-Small-Tracking, 0px);
  }
`;

export const SearchLink = styled(Link)`
  margin: 0;
  width: fit-content;
  padding: 2px 4px;
  color: ${({ theme }) => theme.colors.neutral.dark};
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.25px;
  border-radius: 4px;
  transition: all 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary.default};
    text-decoration: underline;
  }

  &:focus {
    color: ${({ theme }) => theme.colors.primary.default};
    text-decoration: underline;
  }
`;

export const ContainerButtons = styled.div `
  display: flex;
  justify-content: space-between;
`